<template>
    <div class="sc03">
        <h3><span class="tit-st"><b>디지털도시</b> 강남</span> 생활편의 정보</h3>
        <a href="" class="btn-more">더보기</a>

        <div class="sc03_01">
            <div class="main_lifeconv_info">
                <div class="lifemap_list ps-01" @click.prevent="movePage('hosPhar')" style="cursor: pointer;">
                    <div class="lifemap_bnr01">
                        <p class="b_tit">야간 운영<br>병의원·약국 정보</p>
                        <p class="b_txt">※ 야간(22시 이후) 및 심야, 공휴일 운영되는 병의원 · 약국 정보입니다.</p>
                    </div>
                </div>

                <div class="lifemap_list ps-02" @click.prevent="movePage('apart')" style="cursor: pointer;">
                    <div class="lifemap_bnr02">
                        <p class="b_tit">부동산(아파트)<br>실거래내역</p>
                        <p class="b_txt">※ 국토교통부 기준 아파트 실거래 내역을 조회하실수 있습니다.</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- sc03_01//end -->

        <div class="sc03_02">
            <div class="main_lifeconv_info2">
                <h4>공공기관 일자리 정보</h4>
                <a href="" class="btn-more" @click.prevent="movePage('incrude')">더보기</a>
                <div class="lifemap_list ps-03">
                    <ul class="list scroll">
                        <li v-for="(work, idx) in workIncrudeInfo" :key="'work_'+ idx">
                            <div class="txt" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ work.company }}-{{ work.title }}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        
        
        
        
        
        <!-- <h3><span class="tit-st"><b>대한민국</b> 1등 특별구</span> 디지털도시 강남</h3>
        <a :href="$_WC.cp + 'biz'" class="btn-more">더보기</a> -->

        <!-- 20240412 정책강남 미래를 그리는 강남 숨김처리 -->
        <!-- <div class="sc03_01">
            <h4>미래를 그리는 강남</h4>
            <div class="sc03_01_ban">
                <a :href="$cp + 'biz'"
                    @click.prevent="moveClazzGn(1)"
                    class="sc03_01_ban01">
                    대한민국 랜드마크 글로벌도시
                </a>
                <a :href="$cp + 'biz'"
                    @click.prevent="moveClazzGn(2)"
                    class="sc03_01_ban02">
                    꿈이 모이는 도시
                </a>
                <a :href="$cp + 'biz'"
                    @click.prevent="moveClazzGn(3)"
                    class="sc03_01_ban03">
                    대한민국리더 스마트도시
                </a>
            </div>
        </div>


        <div class="sc03_02">
            <h4>정책 강남</h4>
            <div class="sc03_02_ban">
                <div class="sc03_02_area tabs5">
                    <div class="sc03_tab tab5">
                        <ul>
                            <li @click.prevent="selectBizTab('promise', 0)">
                                <a href="#tab01" :class="[bizTab == 'promise' ? 'tab01 on' : 'tab01']">공약사업</a>
                            </li>
                            <li @click.prevent="selectBizTab('major', 1)">
                                <a href="#tab02" :class="[bizTab == 'major' ? 'tab02 on' : 'tab02']">역점사업</a>
                            </li>
                            <li @click.prevent="selectBizTab('smart', 2)">
                                <a href="#tab03" :class="[bizTab == 'smart' ? 'tab03 on' : 'tab03']">스마트도시사업</a>
                            </li>
                        </ul>
                    </div>
                    <div class="content_area pt01 tabcont5" id="tab01"
                        :style="bizTab == 'promise' ? 'display: block;' : ''">
                        <div class="contentL">
                            <div class="text_t">구민과의 약속!<br><b>공약사업</b></div>

                            <div class="percent">
                                <span class="title">{{promiseMaxDate}}년 이행률</span>
                                <p class="progress">
                                    <span class="progress_bar">
                                        <span class="bar"
                                            :style="'width:'+ promiseAllRate +'%'"></span>
                                        <span class="per">{{promiseAllRate}}%</span>
                                    </span>
                                </p>
                            </div>

                        </div>
                        <div class="contentR">
                            <ul class="pi_grp">
                                <li v-for="promise in promiseRateList" :key="promise.code">
                                    <p class="txt"><span v-html="$options.filters.newLineToBr(setPromiseTitle(promise.code, promise.title))"></span></p>
                                    <p :class="['grp_bar '+ promise.clazz]" :style="'height: '+promise.rate+'%'">
                                        <span>{{ promise.rate }}%</span></p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="content_area pt02 tabcont5" id="tab02"
                        :style="bizTab == 'major' ? 'display: block;' : ''">
                        <div class="contentL">
                            <div class="text_t">구민과의 희망!<br><b>역점사업</b></div>
                            <div class="percent">
                                <span class="title">{{majorMaxDate}}년 이행률</span>
                                <p class="progress">
                                    <span class="progress_bar">
                                        <span class="bar"
                                            :style="'width:'+ majorAllRate +'%'"></span>
                                        <span class="per">{{majorAllRate}}%</span>
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="contentR">
                            <ul class="pi_grp pos2">
                                <li v-for="major in majorRateList" :key="major.code">
                                    <p class="txt"><span v-html="$options.filters.newLineToBr(setMajorTitle(major.code, major.title))"></span></p>
                                    <p :class="['grp_bar '+ major.clazz]" :style="'height: '+major.rate+'%'">
                                        <span>{{ major.rate }}%</span></p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="content_area pt03 tabcont5" id="tab03"
                        :style="bizTab == 'smart' ? 'display: block;' : ''">
                        <div class="contentL">
                            <div class="text_t">대한민국 리더<br><b>스마트도시사업</b></div>
                            <div class="percent">
                                <span class="title">{{smartMaxDate}}년 이행률</span>
                                <p class="progress">
                                    <span class="progress_bar">
                                        <span class="bar"
                                            :style="'width:'+ smartAllRate +'%'"></span>
                                        <span class="per">{{smartAllRate}}%</span>
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="contentR">
                            <ul class="pi_grp">
                                <li v-for="smart in smartRateList" :key="smart.code">
                                    <p class="txt"><span v-html="$options.filters.newLineToBr(setSmartTitle(smart.code, smart.title))"></span></p>
                                    <p :class="['grp_bar '+ smart.clazz]" :style="'height: '+smart.rate+'%'">
                                        <span>{{ smart.rate }}%</span></p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->


        <!-- <div class="sc03_03">
            <h4>강남 Maps</h4>
            <div class="data-sgC mt-10">
                <a :href="$cp + 'lifemap'" style="width: 100%; height: 100%;">
                    <div class="sgC gnmap">
                        <p class="tit">한눈에 보는 <span>강남MAP</span></p>
                        <p class="txt">강남구의 인구, 시설, 둘레길 등을<br />한눈에 지도로 볼 수 있습니다.</p>
                    </div>
                </a>
            </div>
        </div> -->
        <News />

    </div>
</template>

<script>
import commonConstMixin from "@/stores/common.const.mixin.js";
import gripUtil from "@/libs/grip.util";
import {$_WC, $_TYPE} from '@/confs/common.const.js';
import { mapGetters } from 'vuex';
import News from "@/views/main/News.vue";

export default {
    name: 'Biz',
    data() {
        return {
            bizTab:'promise',
            isInterval: true,
            phaseIdx: 0,
            phaseList:['promise', 'major', 'smart'],
        };
    },
    components: {
        News,
    },
    computed: {
        ...mapGetters({
            promiseFieldCodeList:'getPromiseFieldCodeList',
            promiseInfoMap:'getPromiseInfoMap',
            smartFieldCodeList: 'getSmartFieldCodeList',
            smartInfoMap: 'getSmartInfoMap',
            majorList: 'getMajorList',
            smartList: 'getSmartList',
            promiseList: 'getPromiseList',
            workIncrudeInfo : 'getWorkIncrudeInfo',
        }),
        promiseRateList() {
            // list = this.promiseList;
            let returnList = [];
            let dataMap = gripUtil.toMap(this.promiseList, 'val20');
            let codeMap = gripUtil.toMap(this.promiseFieldCodeList,'commonCode');
            let infoMap = this.promiseInfoMap;
            for(let key in infoMap) {
                let title = '';
                let rate = 0;
                let dataSeq = infoMap[key].dataSeq;
                if(typeof codeMap[key] !== $_TYPE.UNDEF) {
                    title = codeMap[key][0].localeTitle;
                }
                if(typeof dataMap[dataSeq] !== $_TYPE.UNDEF) {
                    rate = this.getRate(dataMap[dataSeq]);
                }

                let clazz = this.getBarClazz(dataSeq);
                let info = {title: title, rate: rate, clazz: clazz, code:key};
                returnList.push(info);
            }
            return returnList;
        },
        promiseAllRate() {
            let list = this.promiseRateList;
            let rate = 0;
            let sum = 0;
            if(typeof list !== $_TYPE.UNDEF && list.length > 0) {
                list.forEach((d) => {
                    sum += Number(d.rate);
                })
                rate = sum / list.length;
            }
            if(rate > 100 ) {
                rate = 100;
            }
            if(rate > 0 && rate < 1){
                return rate.toFixed(1);
            } else {
                return rate.toFixed(0);
            }
        },
        smartRateList() {
            let returnList = [];
            let dataMap = gripUtil.toMap(this.smartList, 'val20');
            let codeMap = gripUtil.toMap(this.smartFieldCodeList,'commonCode');
            let infoMap = this.smartInfoMap;
            for(let key in infoMap) {
                let title = '';
                let rate = 0;
                let dataSeq = infoMap[key].dataSeq;
                if(typeof codeMap[key] !== $_TYPE.UNDEF) {
                    title = codeMap[key][0].localeTitle;
                }
                if(typeof dataMap[dataSeq] !== $_TYPE.UNDEF) {
                    rate = this.getRate(dataMap[dataSeq]);
                }

                let clazz = this.getBarClazz(dataSeq);
                let info = {title: title, rate: rate, clazz: clazz, code: key};
                returnList.push(info);
            }
            return returnList;
        },
        smartAllRate() {
            let list = this.smartRateList;
            let rate = 0;
            let sum = 0;
            if(typeof list !== $_TYPE.UNDEF && list.length > 0) {
                list.forEach((d) => {
                    sum += Number(d.rate);
                })
                rate = sum / list.length;
            }
            if(rate > 100 ) {
                rate = 100;
            }
            if(rate > 0 && rate < 1){
                return rate.toFixed(1);
            } else {
                return rate.toFixed(0);
            }
        },
        majorRateList() {
            let returnList = [];
            let list = this.majorList;
            let dataMap = gripUtil.toMap(list, 'upperDeptNm');
            if(typeof dataMap !== $_TYPE.UNDEF) {
                let idx = 1;
                let title = '';
                let rate = 0;
                for(let key in dataMap) {
                    title = key;
                    rate = this.getRate(dataMap[key]);
                    let clazz = 'c0'+idx;
                    let code = dataMap[key][0].upperDeptId;
                    let info = {title: title, rate: rate, clazz: clazz, code:code};
                    returnList.push(info);
                    idx++;
                }
            }
            return returnList;
        },
        majorAllRate() {
            let list = this.majorRateList;
            let rate = 0;
            let sum = 0;
            if(typeof list !== $_TYPE.UNDEF && list.length > 0) {
                list.forEach((d) => {
                    sum += Number(d.rate);
                })
                rate = sum / list.length;
            }
            if(rate > 100 ) {
                rate = 100;
            }
            if(rate > 0 && rate < 1){
                return rate.toFixed(1);
            } else {
                return rate.toFixed(0);
            }
        },
        majorMaxDate() {
            if(typeof this.majorList !== $_TYPE.UNDEF && this.majorList.length > 0 ) {
                return this.majorList[0].basdtVal;
            }
        },
        promiseMaxDate() {
            if(typeof this.promiseList !== $_TYPE.UNDEF && this.promiseList.length > 0 ) {
                return this.promiseList[0].basdtVal;
            }
        },
        smartMaxDate() {
            if(typeof this.smartList !== $_TYPE.UNDEF && this.smartList.length > 0 ) {
                return this.smartList[0].basdtVal;
            }
        },
    },
    created() {
        // this.bizTabPlay();
    },
    methods: {
        selectBizTab(tab ,idx) {
            this.bizTab = tab;
            this.phaseIdx = idx;
        },
        getRate(dataList) {
            let ratio = 0;
            let procRatio = procRatio;
            if(dataList.length > 0) {
                dataList.forEach((d) => {
                    if(!isNaN(d.val16)) {
                        ratio += Number(d.val16);
                    }
                })
                procRatio = ratio / dataList.length;
            }
            if(procRatio > 100 ) {
                procRatio = 100;
            }
            if(procRatio > 0 && procRatio < 1){
                return procRatio.toFixed(1);
            } else {
                return procRatio.toFixed(0);
            }
        },
        getBarClazz(dataSeq) {
            switch(dataSeq) {
                case '혁신성장' : return 'c02 promise'; break;
                case '문화생태' : return 'c06 promise'; break;
                case '안심행복' : return 'c08 promise'; break;
                case '공감동행' : return 'c05 promise'; break;
                case '초(超)밀착' : return 'c09 promise'; break;

                case '찾고 싶은 강남' : return 'c02 smart'; break;
                case '포용 하는 강남' : return 'c03 smart'; break;
                case '소통하는 강남' : return 'c05 smart'; break;
                case '살기 편한 강남' : return 'c06 smart'; break;
            }
        },
        moveClazzGn(category) {
            location.href = $_WC.cp + 'biz?category='+category;
        },
        moveArchiving(tab) {
            // console.log('tab', tab);
            location.href = $_WC.cp + 'biz?selectedTab=policy&selectedArchivingTab='+tab;
        },
        phaseBizTab() {
            // 롤링 제거
            // if(this.phaseIdx === (this.phaseList.length - 1)) {
            //     this.phaseIdx = 0;
            // } else {
            //     this.phaseIdx += 1;
            // }
            // let tab = this.phaseList[this.phaseIdx];
            // this.selectBizTab(tab, this.phaseIdx);
        },
        bizTabPlay() {
            this.interval = setInterval(()=>{
                this.phaseBizTab();
            }, 1000 * 10);
        },
        setPromiseTitle(code, title) {
            if($_WC.viewScale === 2){
                return title;
            }
            switch(code) {
                case '1' : return title;
                case '2' : return title;
                case '3' : return title;
                case '4' : return title;
                case '5' : return title;
                default : title;
            }
        },
        setMajorTitle(code, title) {
            // if($_WC.viewScale === 2){
            //     return title;
            // }

            // switch(code) {
            //     case '32201190000' : return title;
            //     case '32202420000' : return '기획 \n 경제국';
            //     case '32202230000' : return '복지 \n 생활국';
            //     case '32202590000' : return '미래 \n 문화국';
            //     case '32201580000' : return '도시 \n 환경국';
            //     case '32201970000' : return '안전 \n 교통국';
            //     case '32200330000' : return title;
            //     default : title;
            // }
            
            if(title.length > 3) {
                title = title.substring(0, 2) + '\n' + title.substring(2, title.length);
            }
            return title;
        },
        setSmartTitle(code, title) {
            if($_WC.viewScale === 2){
                return title;
            }
            switch(code) {
                case '1' : return this.subStrTitle(title);
                case '2' : return this.subStrTitle(title);
                case '3' : return this.subStrTitle(title);
                case '4' : return this.subStrTitle(title);
                default : title;
            }
        },
        subStrTitle(title) {
            let idx = title.indexOf('강남');
            title = title.substring(0, idx) + '\n' + title.substring(idx, title.length);
            return title;
        },
        movePage(cate){
            if(!!cate) {
                window.location.href= $_WC.cp + "lfcnvnc?lfcnvncTab=" + cate;
            }
        },
    },
    mixins: [commonConstMixin],
};
</script>

<style>
.sc03_02 .pi_grp>li .grp_bar.promise{width: 16px;}
.sc03_02 .pi_grp>li .grp_bar.smart{width: 16px;}
</style>
